//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from '@/models'

export default {
  data () {
    return {
      loading: false,
      userLists: {

      }
    }
  },
  props: {
    userId: {
      type: String,
      default: null
    }
  },

  methods: {
    goToList (list) {
      this.$router.push({
        name: 'list',
        params: {
          id: list.id
        }
      })
    }
  },

  created () {
    if (this.loading) {
      return 
    }

    this.loading = true

    Post.getPublicLists(this.userId).then(lists => {
      this.userLists = lists
      this.loading = false 
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-msg/UserMsgLists.vue